'use client';
import React, { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n/config';
import { useGlobalStore } from '@/store/useGlobalStore';

export default function I18nProvider({ children }: { children: React.ReactNode }) {
  const { language, isRTL, theme } = useGlobalStore();

  useEffect(() => {
    i18n.changeLanguage(language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language, isRTL]);

  useEffect(() => {
    if (theme === 'light') {
      document.documentElement.setAttribute('data-theme', 'light');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [theme]);

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}